import type { ComicPanel, Rect } from "./comicTypes";

export function pointInRect(point: { x: number; y: number }, rect: Rect): boolean {
  return (
    point.x >= rect.x &&
    point.y >= rect.y &&
    point.x <= rect.x + rect.width &&
    point.y <= rect.y + rect.height
  );
}

export function panelAtPoint(
  panels: ReadonlyArray<ComicPanel>,
  point: { x: number; y: number },
): ComicPanel | undefined {
  return panels.find((panel) => pointInRect(point, panel));
}

export function rectsOverlap(left: Rect, right: Rect): boolean {
  return (
    left.x < right.x + right.width &&
    left.x + left.width > right.x &&
    left.y < right.y + right.height &&
    left.y + left.height > right.y
  );
}

export function isPanelGeometryValid(
  panels: ReadonlyArray<ComicPanel>,
  pageWidth: number,
  pageHeight: number,
): boolean {
  const ids = new Set<string>();
  for (const panel of panels) {
    if (
      !panel.id ||
      ids.has(panel.id) ||
      ![panel.x, panel.y, panel.width, panel.height, panel.order, panel.templateSlot].every(
        Number.isFinite,
      ) ||
      panel.width <= 0 ||
      panel.height <= 0 ||
      panel.x < 0 ||
      panel.y < 0 ||
      panel.x + panel.width > pageWidth ||
      panel.y + panel.height > pageHeight
    ) {
      return false;
    }
    ids.add(panel.id);
  }
  for (let left = 0; left < panels.length; left += 1) {
    for (let right = left + 1; right < panels.length; right += 1) {
      if (rectsOverlap(panels[left]!, panels[right]!)) return false;
    }
  }
  return true;
}
